import React from 'react';
import { useHistory } from 'react-router-dom';
import Heading from '@fenderdigital/ui/Heading';
import Button from '@fenderdigital/ui/Button';
import Spacer from '@fenderdigital/ui/Spacer';
import { useEscapeKey, useFocusTrap } from '@fenderdigital/custom-hooks';
import { CTACopy, DismissCopy01 } from './AdConfig';
import { AdIdentifier, FreemiumAdProps } from './types';
import {
  FreemiumAdOverlay,
  FreemiumAdContainer,
  AdImageWire,
  AdCopyContainer,
  HeadingLine,
  TimeLeftSpan,
  IgnoreButton,
  Disclaimer,
} from './FreemiumAd-styled';

const FreemiumAd: React.FC<FreemiumAdProps> = ({
  onDismiss,
  onUpgrade,
  isMobile,
  ad,
  showLargeHeadline,
}) => {
  const history = useHistory();
  const imageSrc = isMobile ? ad.mobile : ad.desktop;
  const bundlesAvailable = process.env.REACT_APP_BUNDLES === 'true';
  const modalRef = useFocusTrap();
  const modalInnerRef = useEscapeKey<HTMLDivElement>(() => onDismiss());

  return (
    <>
      <FreemiumAdContainer
        id="play-ad"
        data-id="freemium-ad"
        ref={modalRef}
        role="dialog"
        aria-modal
        aria-labelledby="bundle-heading"
      >
        <AdImageWire
          src={`${imageSrc}.jpg`}
          srcSet={`${imageSrc}.jpg 1x, ${imageSrc}@2x.jpg 2x`}
          alt={ad.alt}
        />
        <AdCopyContainer ref={modalInnerRef}>
          <Heading as="h2" fontFamily="futuraDemi" textSize="f5" id="bundle-heading">
            <HeadingLine>{ad.adCopy[0]}</HeadingLine>
            <Spacer spacing="sm3" />
            <HeadingLine>
              {ad.adCopy[1]}
              {!showLargeHeadline ? (
                <>
                  <Spacer spacing="md1" />
                  <TimeLeftSpan>{ad.adCopy[2]}</TimeLeftSpan>
                  <Spacer spacing="md4" />
                </>
              ) : (
                <Spacer spacing="md3" />
              )}
            </HeadingLine>
          </Heading>
          <Button
            shape="pill"
            isFluid
            dataId="freemium-ad-button"
            onClick={(): void => {
              onUpgrade();
              history.push(bundlesAvailable ? '/plans' : '/plans/upgrade');
            }}
          >
            {CTACopy}
          </Button>
          <Spacer direction="vertical" spacing="sm2" />
          <IgnoreButton
            isFluid
            colorScheme="white"
            textColor="black"
            hoverColor="white"
            data-id="freemium-ad-ignore-button"
            onClick={(): void => {
              onDismiss();
            }}
          >
            {DismissCopy01}
          </IgnoreButton>
          {ad.adIdentifier === AdIdentifier.GEAR_DISCOUNT && (
            <Disclaimer>{ad.adCopy[2]}</Disclaimer>
          )}
        </AdCopyContainer>
      </FreemiumAdContainer>
      <FreemiumAdOverlay />
    </>
  );
};

export default FreemiumAd;
